import { css } from '@emotion/css';
import { Colors } from '../../../shared/styles/colors';
import { PowerTypeEnum, SourceTypeEnum } from '../../../shared/types/enums';
import { Socket, Source, Valve } from '../../../shared/types/server-types';
import { Motion, Radius, unstyledButton } from '../../../shared/styles/tokens';

export type CardStyle = {
  borderStyle: string;
  backgroundStyle: string;
  colorStyle: string;
  svgStyle: string;
};

//TODO: DEPRECATED: remove replace/unify with pedestal page styles
export const determineCardStyle = (source: Source): CardStyle => {
  let style: CardStyle;

  if (source.state.activated) {
    style = {
      backgroundStyle: Colors.SURFACE,
      borderStyle: Colors.BORDER,
      colorStyle: Colors.WINDOW_GRAY,
      svgStyle: Colors.WINDOW_GRAY,
    };
  } else {
    if ((source as Valve).type === SourceTypeEnum.VALVE) {
      style = {
        backgroundStyle: Colors.WHITE,
        borderStyle: Colors.CAPRI_BLUE,
        colorStyle: Colors.CAPRI_BLUE,
        svgStyle: Colors.SOURCE_AVAILABLE,
      };
    } else {
      if ((source as Socket).phase === PowerTypeEnum.SINGLE) {
        style = {
          backgroundStyle: Colors.WHITE,
          borderStyle: Colors.MONO_PHASE,
          colorStyle: Colors.BLACK,
          svgStyle: Colors.SOURCE_AVAILABLE,
        };
      } else {
        style = {
          backgroundStyle: Colors.WHITE,
          borderStyle: Colors.THREE_PHASE,
          colorStyle: Colors.BLACK,
          svgStyle: Colors.SOURCE_AVAILABLE,
        };
      }
    }
  }
  return style;
};

export const reactiveCardStyle = (cardStyle: CardStyle): string => css`
  border: 2px solid ${cardStyle.borderStyle};
  background-color: ${cardStyle.backgroundStyle};
  color: ${cardStyle.colorStyle};
  figure {
    h4 {
      color: ${cardStyle.colorStyle};
    }
    svg {
      path {
        fill: ${cardStyle.svgStyle};
      }
    }
  }
`;

export const sourceCardStyle = css`
  ${unstyledButton}
  min-width: 0;
  min-height: 4.5rem;
  width: 100%;
  cursor: pointer;
  border: 2px solid ${Colors.MONO_PHASE};
  border-radius: ${Radius.md};
  transition:
    background-color ${Motion.base},
    border-color ${Motion.base},
    color ${Motion.base},
    transform ${Motion.fast},
    box-shadow ${Motion.fast};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.75rem 0.875rem;
  text-align: left;
  figure {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    padding: 0px;

    h4 {
      text-transform: capitalize;
      transition: color ${Motion.base};
      min-width: 0;
    }
    svg {
      flex: 0 0 auto;
      path {
        transition: fill ${Motion.base};
      }
    }
  }
  label {
    cursor: pointer;
    color: ${Colors.TEXT_SECONDARY};
    margin-top: 0.25rem;
  }

  @media (hover: hover) {
    &:hover {
      box-shadow: 0 6px 16px -10px rgba(16, 42, 67, 0.35);
    }
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: 2px solid ${Colors.CAPRI_BLUE};
    outline-offset: 2px;
  }
`;
